var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRounded = function SvgRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M12.662 4.153a.75.75 0 0 0-1.332 0L9.016 8.582l-5.018.833a.749.749 0 0 0-.413 1.265l3.576 3.653-.76 5.056a.75.75 0 0 0 1.08.78l4.516-2.288 4.518 2.288a.75.75 0 0 0 1.079-.78l-.763-5.054 3.577-3.653a.751.751 0 0 0-.414-1.264l-5.017-.834z",
    clipRule: "evenodd"
  })));
};
export default SvgRounded;